import type { InputHTMLAttributes, ReactNode } from 'react';

export interface ListPageSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /**
   * Page-specific attribute overrides for the search input
   * (e.g. `type: 'text'`, `name`, a custom `aria-label`).
   * Spread last, so they win over the defaults below.
   */
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
}

interface MobileListHeaderProps {
  title: string;
  /** Optional action rendered next to the title (e.g. a create button). */
  action?: ReactNode;
  search: ListPageSearchProps;
}

/**
 * Mobile header shared by Dashboard V2 list pages:
 * page title (+ optional action button) and the search input.
 */
export const MobileListHeader = ({ title, action, search }: MobileListHeaderProps) => (
  <header className="mobile-header">
    <div className="mobile-header-top">
      <h1 className="mobile-header-title">{title}</h1>
      {action}
    </div>
    <div className="mobile-search-wrapper">
      <span className="mobile-search-icon" aria-hidden="true">
        <span className="material-symbols-outlined">search</span>
      </span>
      <input
        type="search"
        className="mobile-search-input"
        placeholder={search.placeholder}
        value={search.value}
        onChange={(e) => search.onChange(e.target.value)}
        aria-label={search.placeholder}
        autoComplete="off"
        spellCheck="false"
        {...search.inputProps}
      />
    </div>
  </header>
);

export default MobileListHeader;
